<div class="category-description">Categories help organize your zones and provide an extra level of customization.</div>
<div class="category-content" fxLayout="column">
  <app-search-bar (searchTerm)="searchTerm$.next($event)"></app-search-bar>
  <div class="category-list" *ngIf="(categories$ | async) as categories; else loading">
  <ng-container *ngTemplateOutlet="error ? errorMessage : categoryList; context: { $implicit: categories }"></ng-container>
 </div>
</div>

<div class="category-actions">
  <button class="category-create-btn">Create category</button> 
</div>

<ng-template #categoryList let-categories>
  <div *ngIf="categories.length <= 0" class="no-result">No category found</div>

  <ng-container *ngIf="categories.length > 0">
    <div *ngFor="let category of categories" class="category-item" (click)="selectCategory(category)" fxLayout="row">
      <div class="circle-color" [ngStyle]="getStyles(category)"></div>
      <div class="category-name">{{ category.name }}</div>
    </div>
  </ng-container>
</ng-template>

<ng-template #loading>
  <div class="category-loading-spinner">
    <app-spinner></app-spinner>
  </div>
</ng-template>

<ng-template #errorMessage>
  <div class="errorMessage">{{ error }}</div>
</ng-template>
